import React, { useState } from "react";
import "./BSNAuth.css";
import BSNlogo from "../assets/bsn-logo.png";
import bsngif from "../assets/Verificationbsn.gif";
import checkedg from "../assets/checkedone.png";
import alreadyscanned from "../assets/already-scannned.png";
import fake from "../assets/fakex.png";
import { toast } from "react-hot-toast";
import Loader from "../components/Loader";
import BSNService from "../services/BSNService";

const BSNAuth = () => {
  const bsnService = new BSNService();
  const [formData, setFormData] = useState({
    SerialNo: "",
    BatchNo: ""
  });

  const [errors, setErrors] = useState({ SerialNo: "", BatchNo: "" });

  const [state, setState] = useState({
    loading: false,
    isAuthenticated: false,
    isGenuine: false,
    isAlreadyScanned: false,
    isFake: false,
    productName: ""
  });

  function changeHandler(event) {
    setFormData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value
    }));
  }

  async function submitHandler(event) {
    event.preventDefault();

    const validationErrors = {};

    if (!formData.SerialNo) {
      validationErrors.SerialNo = "Enter Serial No.";
    }

    if (!formData.BatchNo) {
      validationErrors.BatchNo = "Enter Batch No.";
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      setState((prevData) => ({
        ...prevData,
        loading: true
      }));
      event.preventDefault();
      try {
        const obj = {
          SerialNo: formData.SerialNo,
          BatchNo: formData.BatchNo
        };
        bsnService.CheckBSNQR(obj).then((response) => {
          setState((prevData) => ({
            ...prevData,
            loading: false
          }));
          if (response.responseCode == 200) {
            setState((prevData) => ({
              ...prevData,
              loading: false,
              isAuthenticated: true,
              isGenuine: true,
              isAlreadyScanned: false,
              isFake: false,
              productName: response.productName
            }));
          } else if (response.responseCode == 201) {
            setState((prevData) => ({
              ...prevData,
              loading: false,
              isAuthenticated: true,
              isGenuine: false,
              isAlreadyScanned: true,
              isFake: false,
              productName: response.productName
            }));
          } else if (response.responseCode == 400) {
            setState((prevData) => ({
              ...prevData,
              loading: false,
              isAuthenticated: true,
              isGenuine: false,
              isAlreadyScanned: false,
              isFake: true,
              productName: ""
            }));
          }
        });
      } catch (error) {
        setState((prevData) => ({
          ...prevData,
          loading: false,
          isAuthenticated: false
        }));
        toast.error("Something went wrong");
      }
    }
  }

  return (
    <div>
      {state.loading ? (
        <Loader />
      ) : (
        <div>
          <section hidden={state.isAuthenticated} className="verify-product">
            <div className="container-fluid firstcont">
              <div className="row">
                <div className="col-md-12 formcolo">
                  <div className="container-fluid scontinside">
                    <div className="row">
                      <div className="col-md-12">
                        <img
                          src={BSNlogo}
                          className="bsnlogo"
                          alt="slider"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 bsnvypcol">
                        <span className="vfyp">Verify Your Product</span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <form className="bsnformone" onSubmit={submitHandler}>
                          <div className="text-left">
                            <span>
                              <label className="bsnform-label">Serial No</label>
                            </span>
                            <span className="mand">*</span>
                            <input
                              type="number"
                              value={formData.SerialNo}
                              onChange={changeHandler}
                              name="SerialNo"
                              className="form-control inpt-base"
                              placeholder="Enter Serial No."
                            />
                            {errors.SerialNo && (
                              <div className="text-red-500 mb-3">
                                {errors.SerialNo}
                              </div>
                            )}
                          </div>

                          <div className="text-left mt-3">
                            <span>
                              <label className="bsnform-label">Batch No</label>
                            </span>
                            <span className="mand">*</span>
                            <input
                              type="text"
                              value={formData.BatchNo}
                              onChange={changeHandler}
                              name="BatchNo"
                              className="form-control inpt-base"
                              placeholder="Enter Batch No."
                            />
                            {errors.BatchNo && (
                              <div className="text-red-500  mb-3">
                                {errors.BatchNo}
                              </div>
                            )}
                          </div>

                          <div className="row mt-3">
                            <div className="col-md-12 ">
                              <button className="btn btn-primary w-100 verifybtnbsn">
                                Verify
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>

                    <div className="row mt-4">
                      <div className="col-md-12 gif-container">
                        <img
                          src={bsngif}
                          className="bsngif"
                          alt="slider"
                          loading="lazy"
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 bsnvypcol">
                        <span className="powerby">
                          Powered by{" "}
                          <span className="holo">
                            <a href="https://holostik.com/" target="_blank">
                              Holostik
                            </a>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* verify-result */}
          <section hidden={!state.isAuthenticated} className="verify-product">
            <div className="container-fluid bsnfirstcont">
              <div className="row">
                <div className="col-md-12 formcolo">
                  <div className="container-fluid scontinside">
                    <div className="row">
                      <div className="col-md-12 bsnlogocol">
                        <img
                          src={BSNlogo}
                          className="bsnlogo"
                          alt="slider"
                          loading="lazy"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 purplecontcol">
                        <div className="container-fluid purplecont">
                          <div className="row">
                            <div className="col-md-12">
                              <span className="result-header-text">
                                Product Verification Result
                              </span>
                            </div>
                          </div>
                          <div className="row cardrow">
                            <div className="col-md-12 productdetail">
                              <div className="container-fluid">
                                <div hidden={!state.isGenuine} className="row">
                                  <div className="col-md-12 gfaimgcolo d-flex justify-content-center ">
                                    <img
                                      src={checkedg}
                                      className="gicn"
                                      alt="slider"
                                      loading="lazy"
                                    />
                                  </div>
                                  <div className="col-md-12 d-flex justify-content-center">
                                    <span className="bsnthanks_text">
                                      Thanks for Buying Genuine Product
                                    </span>
                                  </div>
                                </div>
                                {/* already scanned */}
                                <div
                                  hidden={!state.isAlreadyScanned}
                                  className="row"
                                >
                                  <div className="col-md-12 gfaimgcolo d-flex justify-content-center ">
                                    <img
                                      src={alreadyscanned}
                                      className="gicn"
                                      alt="slider"
                                      loading="lazy"
                                    />
                                  </div>
                                  <div className="col-md-12 d-flex justify-content-center">
                                    <span className="bsnthanks_text">
                                      Already Scanned Product
                                    </span>
                                  </div>
                                </div>
                                {/* fake */}
                                <div hidden={!state.isFake} className="row">
                                  <div className="col-md-12 gfaimgcolo d-flex justify-content-center ">
                                    <img
                                      src={alreadyscanned}
                                      className="gicn"
                                      alt="slider"
                                      loading="lazy"
                                    />
                                  </div>
                                  <div className="col-md-12 mt-3 d-flex justify-content-center">
                                    <span style={{ color: "white" }}>
                                      Seems you’ve entered incorrect details.
                                      Please try again or connect with customer
                                      care to help authenticate your product.
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      hidden={!state.productName != ""}
                      className="row productrow"
                    >
                      <div className="col-md-12 productncol">
                        <span className="product_name">
                          {state.productName}
                        </span>
                      </div>
                    </div>

                    {/* contact detail */}
                    <div className="row tqueryrow">
                      <div className="col-md-12 tquerycol">
                        <span>
                          In case of any queries & complaints please contact our
                          Customer Care Team.
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 callquerycol">
                        <ul className="bsncontact_dul">
                          <li className="bsnemail">
                            <span className="icn mr-1">
                              <i class="bi bi-telephone-fill"></i>
                            </span>
                            <a href="tel:+911149594959">+91-11-49594959</a>
                          </li>
                          <li className="bsnemail">
                            <span className="icn mr-1">
                              <i class="bi bi-envelope-fill"></i>
                            </span>{" "}
                            <a href="mailto:indiacustomercare@glanbia.com">
                              indiacustomercare@glanbia.com
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>

                    {/* end contact detail */}

                    <div className="row">
                      <div className="col-md-12 bsnvypcol">
                        <span className="powerby">
                          Powered by{" "}
                          <span className="holo">
                            <a href="https://holostik.com/" target="_blank">
                              Holostik
                            </a>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </div>
  );
};

export default BSNAuth;
